import React, { useEffect, useState } from "react"
import { SaveButton } from "components/Buttons"
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"
import { Card, CardBody, Col, Row } from "reactstrap"
import { getBookingDateReports } from "store/actions"
import { connect } from "react-redux"

const BookingReportsChart = ({
  getBookingDateReports,
  bookingDateReports,
  calendarGroupId,
  subCalendarId,
}) => {
  const [rangeToggle, setRangeToggle] = useState("year")
  const [chartData, setChartData] = useState([])
  const [label, setLabel] = useState("Month")

  useEffect(() => {
    getBookingDateReports({
      ...(calendarGroupId ? { calendar_id: calendarGroupId } : {}),
      ...(subCalendarId ? { booking_type_id: subCalendarId } : {}),
    })
  }, [calendarGroupId, subCalendarId])

  useEffect(() => {
    let data = []
    if (rangeToggle === "year" && bookingDateReports?.year_months) {
      for (const index in bookingDateReports?.year_months) {
        data.push({
          label: bookingDateReports?.year_months[index].month,
          value: bookingDateReports?.year_months[index].bookings_count,
        })
      }
      setLabel("Month")
    } else if (rangeToggle === "week" && bookingDateReports?.week_days) {
      for (const index in bookingDateReports?.week_days) {
        data.push({
          label: bookingDateReports?.week_days[index].name,
          value: bookingDateReports?.week_days[index].bookings_count,
        })
      }
      setLabel("Day of Week")
    } else if (rangeToggle === "month" && bookingDateReports?.month_days) {
      for (const index in bookingDateReports?.month_days) {
        data.push({
          label: bookingDateReports?.month_days[index].day,
          value: bookingDateReports?.month_days[index].bookings_count,
        })
      }
      setLabel("Day of Month")
    }
    setChartData(data)
  }, [rangeToggle, bookingDateReports])

  return (
    <Card>
      <CardBody>
        <Row className="ms-4">
          <Col>
            <h5># of Bookings per{" " + label}</h5>
          </Col>
        </Row>
        <Row className="d-flex justify-content-end mt-1">
          <Col xs="auto">
            <SaveButton
              type="button"
              color={rangeToggle === "week" ? "primary" : "secondary"}
              size="sm"
              content="Week"
              onClick={() => setRangeToggle("week")}
              disabled={!bookingDateReports}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              color={rangeToggle === "month" ? "primary" : "secondary"}
              size="sm"
              content="Month"
              onClick={() => setRangeToggle("month")}
              disabled={!bookingDateReports}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              color={rangeToggle === "year" ? "primary" : "secondary"}
              size="sm"
              content="Year"
              onClick={() => setRangeToggle("year")}
              disabled={!bookingDateReports}
            />
          </Col>
        </Row>
        <Row className="ms-3" style={{ height: "500px" }}>
          <Col>
            <ResponsiveContainer>
              <BarChart
                data={chartData}
                width={500}
                height={500}
                margin={{
                  top: 20,
                  right: 30,
                  left: 20,
                  bottom: 15,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="label"
                  tick={{
                    stroke: "black",
                    strokeWidth: 0.5,
                  }}
                  dy={10}
                  label={{
                    value: label,
                    position: "bottom",
                  }}
                />
                <YAxis
                  label={{
                    value: "# of Bookings",
                    angle: -90,
                    position: "insideLeft",
                  }}
                  tick={{
                    stroke: "black",
                    strokeWidth: 0.5,
                  }}
                  dx={-10}
                  allowDecimals={false}
                />
                <Tooltip cursor={{ fill: "rgb(220, 220, 220, 0.5)" }} />
                <Bar
                  dataKey="value"
                  name="# of Bookings"
                  fill="#556ee6"
                  maxBarSize={50}
                  //   label={props => {
                  //     return (
                  //       <text
                  //         x={props?.x}
                  //         y={props?.y}
                  //         dy={-15}
                  //         dx={25}
                  //         fontSize={14}
                  //         textAnchor="middle"
                  //       >
                  //         {props?.value > 0 ? "" : "No Bookings"}
                  //       </text>
                  //     )
                  //   }}
                />
              </BarChart>
            </ResponsiveContainer>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const mapStateToProps = state => ({
  bookingDateReports: state.BookingsFeature.bookingDateReports,
})

const mapDispatchToProps = dispatch => ({
  getBookingDateReports: values => dispatch(getBookingDateReports(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BookingReportsChart)
